import { createSlice } from "@reduxjs/toolkit";
import { deleteFileAPI } from "../../services/deleteFile";

const initialState = {
    isLoading: false,
    error: "",
    message: "",
    data: null,
};

const deleteFileSlice = createSlice({
    name: "deleteFile",
    initialState,
    reducers: {
        deleteFileInfo(state) {
            state.isLoading = true;
            state.error = "";
            state.message = "";
        },
        deleteFileInfoSuccess(state, action) {
            state.isLoading = false;
            state.data = action.payload;
            state.error = "";
            state.message = action.payload?.message || "";
        },
        deleteFileInfoFailure(state, action) {
            state.isLoading = false;
            state.message = "";
            state.error =
                typeof action.payload === "string"
                    ? action.payload
                    : action.payload?.message || String(action.payload);
            state.data = null;
        },
        deleteFileInfoReset(state) {
            state.isLoading = false;
            state.message = "";
            state.data = null;
            state.error = "";
        },
    },
});

export const deleteFileHandler = (payload) => async (dispatch) => {
    try {
        dispatch(deleteFileAction.deleteFileInfo());
        const response = await deleteFileAPI(payload);
        dispatch(deleteFileAction.deleteFileInfoSuccess(response));
        return response;
    } catch (e) {
        const errMsg =
            typeof e === "string"
                ? e
                : e?.response?.data?.message || e?.message || String(e);
        dispatch(deleteFileAction.deleteFileInfoFailure(errMsg));
        throw errMsg;
    }
};

export default deleteFileSlice.reducer;
export const deleteFileAction = deleteFileSlice.actions;
